import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import arrowright from "../../assets/arrowright.svg";
import { useSelector } from "react-redux";

const PosOrderTable = ({ additionalData, pagination, onRowClick }) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );

  const openOrderList = (id) => {
    navigate(`/vendorDetails?id=${id}`);
  };

  const data = useMemo(
    () =>
      //   additionalData?.status
      //     ? additionalData?.all_product
      additionalData || [],
    [additionalData],
  );

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);
  console.log("data==>", data);

  const columns = useMemo(
    () => [
      {
        Header: (
          <div className="text-start justify-start" title={t("Session")}>
            {t("Session")}
          </div>
        ),
        width: "5%", // Add this line
        accessor: "session",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">{row.original.session}</div>
        ),
      },

      {
        Header: (
          <div className="text-start" title={t("Receipt Number")}>
            {t("Receipt No.")}
          </div>
        ),
        width: "6%", // Add this line
        accessor: "receipt_no",
        Cell: ({ row }) => (
          <div className="text-start">{`${row.original.receipt_no}`}</div>
        ),
      },

      {
        Header: (
          <div className="text-start justify-start" title={t("Date & Time")}>
            {t("Date & Time")}
          </div>
        ),
        width: "7%", // Add this line
        accessor: "date_order",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">
            {row.original.date_order}
          </div>
        ),
      },

      {
        Header: (
          <div className="text-start" title={t("Customer")}>
            {t("Customer")}
          </div>
        ),
        width: "8%", // Add this line
        accessor: "customer_name",
        Cell: ({ row }) => (
          //   <div className="text-start">{`${row.original.customer_name ? row.original.customer_name : ''} (${row.original.customer_phone})`}</div>
          <div className="text-start">{`${row.original.customer_name ? row.original.customer_name : ""} ${row.original.customer_phone ? `(${row.original.customer_phone})` : "-"}`}</div>
        ),
      },
      {
        Header: (
          <div className="text-start text-balance" title={t("No. of Items")}>
            {t("No. of Items")}
          </div>
        ),
        width: "4%", // Add this line
        accessor: "items",
        Cell: ({ row }) => (
          <div className="text-start">{t(row.original.items)}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Total")}>
            {t("Total")}
          </div>
        ),
        width: "6%", // Add this line
        accessor: "order_value",
        Cell: ({ row }) => (
          <div className="text-start">{`EGP ${row.original.order_value.toFixed(2)}`}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Commission")}>
            {t("Commission")}
          </div>
        ),
        width: "8%", // Add this line
        accessor: "commission",
        Cell: ({ row }) => (
          <div className="text-start">{row.original.commission ? `EGP ${row.original.commission}` : '-'}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Order From")}>
            {t("Order From")}
          </div>
        ),
        width: "8%", // Add this line
        accessor: "order_from",
        Cell: ({ row }) => (
          <div className="text-start">{row.original.order_from ? t(row.original.order_from) : '-'}</div>
        ),
      },
      {
        Header: (
          <div className="text-start text-balance" title={t("Payment Type")}>
            {t("Payment Type")}
          </div>
        ),
        width: "6%", // Add this line
        accessor: "payment",
        Cell: ({ row }) => (
          <div className="text-start">{t(row.original.payment)}</div>
        ),
      },
      {
        Header: (
          <div className="text-start w-full" title={t("User")}>
            {t("User")}
          </div>
        ),
        width: "12%", // better than %
        accessor: "cashier_name",
       Cell: ({ row }) => {
  const value = row.original.cashier_name || "-";

  return (
    <div
      className="text-start max-w-[150px] break-words whitespace-normal"
      title={value}
    >
      {value}
    </div>
  );
}
      },
      {
        Header: (
          <div className="text-start w-full" title={t("Salesman")}>
            {t("Salesman")}
          </div>
        ),
        width: "12%", // better than %
        accessor: "salesman",
            Cell: ({ row }) => {
  const value = row.original.salesman || "-";

  return (
    <div
      className="text-start max-w-[150px] break-words whitespace-normal"
      title={value}
    >
      {value}
    </div>
  );
},
      },

      ...(allStores
        ? [
            {
              Header: (
                <div className="text-start" title={t("Store Name")}>
                  {t("Store Name")}
                </div>
              ),
              width: "10%", // Add this line
              accessor: "store_name",
              Cell: ({ row }) => (
                <div
                  className={`text-start`}
                >{`${row.original.store_name}`}</div>
              ),
            },
          ]
        : []),

      {
        Header: (
          <div className="text-start" title={t("Status")}>
            {t("Status")}
          </div>
        ),
        width: "6%", // Add this line
        accessor: "state",
        Cell: ({ row }) => (
          <div
            className={`text-start px-3 py-1 rounded-3xl bg-[#D1FFDE] w-16 flex justify-center items-center text-[#00B833]
            ${row.original.state === "Paid" ? "bg-[#D1FFDE] text-[#00B833] w-16" : "bg-[#ffd1d1] text-[#ef3a3a]"} w-20`}
          >{`${t(row.original.state)}`}</div>
        ),
      },
      // {
      //   Header: (
      //     <div className="text-start" title={t("App Order")}>
      //       {t("App Order")}
      //     </div>
      //   ),
      //   width: "6%", // Add this line
      //   accessor: "is_app_order",
      //   Cell: ({ row }) => (
      //     <input
      //       type="checkbox"
      //       // disabled
      //       name="is_password_restrict"
      //       className="cursor-pointer w-4 h-4 accent-[#465466]"
      //       checked={row.original.is_app_order}
      //     // onChange={(e) => {
      //     // //   handleCheckboxChange(row.original.retailer_user_id, "is_password_restrict", e.target.checked);
      //     // }}
      //     />
      //     //   <div className="text-start">{t(row.original.change)}</div>
      //   ),
      // },

      {
        id: "action",
        Header: "",
        headerClassName: "text-start",
        // width: 50,
        width: "4%", // Add this line
        accessor: (row) => `${row.original},`,
        Cell: ({ row }) => (
          <>
            <button
              className=" text-[#1b4497] rounded-lg"
              // onClick={() => openOrderList(row.original.order_details.order_no)}
            >
              <img
                src={arrowright}
                alt="arrowright"
                className={`${i18n.language == "en" ? "" : " rotate-180"}`}
                height={3}
                width={20}
              />
            </button>
            {/* )
                  } */}
          </>
        ),
      },
    ],
    [t],
  );

  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect,
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  return (
    <>
      <div
        className="container flex flex-col mt-4 me-3"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Replace the entire "Header Table" div and "Body Table" div with this: */}
            <div
              style={{
                overflowY: "auto",
              }}
              className=" bg-white"
            >
              <table
                className="font-normal overflow-hidden rounded-lg"
                style={{
                  tableLayout: "fixed",
                  minWidth: "1400px",
                  width: "100%",
                }}
              >
                <thead className="sticky top-0 z-10">
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps(),
                            );
                          return (
                           <th
  key={columnKey}
  {...columnProps}
  className="py-3 break-words whitespace-normal"
  style={{ width: column.width }}
>
                              <div className="flex flex-col items-start ms-2 text-sm leading-tight">
                                {column.render("Header")}
                                <span>
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <img
                                        src={Vectorsorting}
                                        style={{ minHeight: 10, minWidth: 10 }}
                                        alt="vector"
                                      />
                                    ) : (
                                      <img
                                        className="rotate-180"
                                        src={Vectorsorting}
                                        alt="vector"
                                      />
                                    )
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>

                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                          onClick={() => onRowClick && onRowClick(row.original)}
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""} ${cell?.column?.Header == "Product" ? "cursor-pointer" : ""}`}
                              style={{ width: cell.column.width }}
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="">
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex != 1 ? true : false}
                canNextPage={data?.length == pageSize ? true : false}
                gotoPage={(page) => {
                  nextPage(page);
                }}
                previousPage={() => {
                  setpageIndex(pageIndex - 1);
                }}
                nextPage={() => {
                  setpageIndex(pageIndex + 1);
                }}
                pageSize={pageSize}
                setPageSize={(pageSize) => {
                  setPageSize(pageSize);
                }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PosOrderTable;
